import React from 'react'
import {
  TextField,
  Grid,
  Box,
} from '@mui/material'
import { Controller } from 'react-hook-form'
import { FormError } from 'shared/FormError'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { isValid } from 'date-fns'

export const InsurancePolicyForm = ({ errors, control }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{xs:12}}>
          <Controller
            name="policyNumber"
            control={control}
            rules={{
              required: 'Policy number is required',
            }}
            render={({ field }) => (
              <TextField
                fullWidth
                label="Policy Number"
                margin="normal"
                {...field}
              />
            )}
          />
          {errors?.policyNumber && <FormError text={errors.policyNumber.message} />}
        </Grid>

        <Grid size={{xs:12}}>
          <Controller
            name="providerName"
            control={control}
            rules={{
              required: 'Provider name is required',
            }}
            render={({ field }) => (
              <TextField
                fullWidth
                label="Provider Name"
                margin="normal"
                {...field}
              />
            )}
          />
          {errors?.providerName && <FormError text={errors.providerName.message} />}
        </Grid>

        <Grid size={{xs:6}}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Controller
              name="effectiveDate"
              control={control}
              rules={{
                required: 'Effective date is required',
                validate: (value) =>
                  value && isValid(value) ? true : 'Invalid date',
              }}
              defaultValue={null}
              render={({
                field: { onChange, value },
              }) => (
                <DatePicker
                  label="Effective Date"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </LocalizationProvider>
          {errors?.effectiveDate && <FormError text={errors.effectiveDate.message} />}
        </Grid>

        <Grid size={{xs:6}}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Controller
              name="expirationDate"
              control={control}
              rules={{
                required: 'Expiration date is required',
                validate: (value) =>
                  value && isValid(value) ? true : 'Invalid date',
              }}
              defaultValue={null}
              render={({
                field: { onChange, value },
              }) => (
                <DatePicker
                  label="Expiration Date"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </LocalizationProvider>
          {errors?.expirationDate && <FormError text={errors.expirationDate.message} />}
        </Grid>
      </Grid>
    </Box>
  )
}
